// extracted by mini-css-extract-plugin
module.exports = {"article_cover":"single-post-template-module--article_cover--BwUtf"};